var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Renderer2, RendererFactory2 } from '@angular/core';
import * as i0 from "@angular/core";
var ToastAlertService = /** @class */ (function () {
    function ToastAlertService(rendererFactory) {
        this.activeToasts = [];
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    ToastAlertService.prototype.add = function (toastAlertItem, id) {
        var _a;
        this.toastAlerts = __assign({}, this.toastAlerts, (_a = {}, _a[id] = toastAlertItem, _a));
    };
    ToastAlertService.prototype.remove = function (id) {
        delete this.toastAlerts[id];
    };
    ToastAlertService.prototype.open = function (id) {
        var toastAlertItem = this.toastAlerts[id];
        this.container = document.getElementById('toast-alert-container');
        if (typeof toastAlertItem === 'undefined') {
            return;
        }
        if (this.activeToasts.includes(toastAlertItem)) {
            toastAlertItem.resetTimer();
        }
        else {
            this.renderer.addClass(toastAlertItem.element, 'IsActive');
            this.renderer.appendChild(this.container, toastAlertItem.element);
            toastAlertItem.toggleVisibility('visible');
            toastAlertItem.startTimer();
            this.addToActiveToasts(toastAlertItem);
        }
    };
    ToastAlertService.prototype.close = function (id) {
        var toastAlertItem = this.toastAlerts[id];
        if (typeof toastAlertItem === 'undefined') {
            return;
        }
        toastAlertItem.toggleVisibility('hidden');
        this.activeToasts = this.activeToasts.filter(function (x) { return x.id !== id; });
        this.repositionItems();
    };
    ToastAlertService.prototype.addToActiveToasts = function (item) {
        this.activeToasts = this.activeToasts.concat([item]);
        this.repositionItems();
    };
    ToastAlertService.prototype.removeElement = function (id) {
        var toastAlertItem = this.toastAlerts[id];
        if (toastAlertItem) {
            this.renderer.removeChild(this.container, toastAlertItem.element);
        }
    };
    ToastAlertService.prototype.repositionItems = function () {
        var offset = 8;
        var position = offset;
        this.activeToasts.forEach(function (item) {
            item.move(position);
            position += item.element.offsetHeight + offset;
        });
    };
    ToastAlertService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ToastAlertService_Factory() { return new ToastAlertService(i0.ɵɵinject(i0.RendererFactory2)); }, token: ToastAlertService, providedIn: "root" });
    return ToastAlertService;
}());
export { ToastAlertService };
